<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-modal">
      <h2>Ver medicamentos prescritos</h2>
    </div>
    @if (isLoading) {
      <app-loading-list></app-loading-list>
    }
    @if (!isLoading) {
      <div class="body-modal">
        @for (itemMedicalCare of medicalCare; track itemMedicalCare; let indexMedicalCare = $index) {
          @if (('validateGeneral' | validateThereArePrescriptions:itemMedicalCare:isHistory:null:idCurrentMedicalCare)) {
            <cdk-accordion-item
              #accordionItemModule="cdkAccordionItem" class="profile-register-accordion-item" role="button" tabindex="0"
              [attr.id]="'accordion-header-' + indexMedicalCare" [attr.aria-expanded]="accordionItemModule.expanded"
              [attr.aria-controls]="'accordion-body-' + indexMedicalCare">
              <div [ngClass]="{'profile-register-accordion-item-header-expanded': accordionItemModule.expanded}"
                class="profile-register-accordion-item-header" (click)="accordionItemModule.toggle()">
                Atendimento Médico - ({{ itemMedicalCare.medicalCare.userName }} - {{
                itemMedicalCare.medicalCare.datetimeInclusion | date:'dd/MM/yy, H:mm' }})
                <span [ngClass]="{'profile-register-accordion-item-description-expanded': accordionItemModule.expanded}"
                  class="profile-register-accordion-item-description">
                  Clique para {{ accordionItemModule.expanded ? 'fechar' : 'abrir' }}
                </span>
              </div>
              <div class="profile-register-accordion-item-body" role="region"
                [style.display]="accordionItemModule.expanded ? '' : 'none'" [attr.id]="'accordion-body-' + indexMedicalCare"
                [attr.aria-labelledby]="'accordion-header-' + indexMedicalCare">
                <div class="feature-content">
                  @if (('validateIndividualList' | validateThereArePrescriptions:itemMedicalCare:isHistory:false:idCurrentMedicalCare)) {
                    <div class="card-list">
                      <div class="title-header">
                        <h4>Lista de Prescrições Internas</h4>
                      </div>
                      <div class="row">
                        @for (item of (itemMedicalCare | filterPrescriptionsSuspension:false:isHistory:idCurrentMedicalCare); track item; let indexPrescription = $index) {
                          @if (isHistory || (!isHistory && item.canSuspend)) {
                            <div class="col-12 col-sm-6 col-md-4">
                              <div class="card-item">
                                <div class="infos">
                                  <span [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescriptionStatusEnum.Suspenso || (!isHistory && validateActionSuspendedPrescription(item.prescriptionMedicine.idPrescriptionMedicine))}" class="primary">{{item.medicineName}}</span>
                                  <span class="secundary">Uso: {{item.usage}}</span>
                                  <span class="secundary">Via: {{item.administrationTypeName}}</span>
                                  <span class="secundary">Apresentação: {{item.presentationName}}</span>
                                  <span class="secundary">Frequência: {{item.frequencyName}}</span>
                                  <span class="secundary">Periodo trat.: {{item.treatmentPeriodName}}</span>
                                  @if (item.motiveSuspended) {
                                    <span [matTooltip]="item.motiveSuspended" class="secundary">Motivo da suspensão: {{item.motiveSuspended | truncateText:50}}</span>
                                  }
                                  @if (item.medicNameSuspended || item.nurseNameSuspended) {
                                    <span class="secundary">
                                      Responsável pela suspensão: {{item.medicNameSuspended ? item.medicNameSuspended : item.nurseNameSuspended}}; {{ item.prescriptionMedicine.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}
                                    </span>
                                  }
                                </div>
                                @if (!isHistory && !validateActionSuspendedPrescription(item.prescriptionMedicine.idPrescriptionMedicine)) {
                                  <div class="actions">
                                    <button>
                                      <mat-icon aria-hidden="false" aria-label="Ver mais"
                                      (click)="openPrescriptionModal(item, false)">block</mat-icon>
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                  @if (('validateIndividualList' | validateThereArePrescriptions:itemMedicalCare:isHistory:true:idCurrentMedicalCare)) {
                    <div class="card-list">
                      <div class="sub-section">
                        <div class="title-header">
                          <h4>Solução medicamentosa</h4>
                        </div>
                      </div>
                      <div class="row row-list">
                        @for (item of (itemMedicalCare | filterPrescriptionsSuspension:true:isHistory:idCurrentMedicalCare); track item; let indexPrescription = $index) {
                          @if (isHistory || (!isHistory && item.canSuspend)) {
                            <div class="col-12 col-sm-6 col-md-4">
                              <div class="card-item">
                                <div class="infos">
                                  @for (medicine of item.listSolutionMedicine; track medicine; let indexMedicine = $index) {
                                    <div>
                                      <span [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescriptionStatusEnum.Suspenso || (!isHistory && validateActionSuspendedSolutionPrescription(item.prescriptionSolution.idPrescriptionSolution))}" class="primary">{{medicine.medicineName}}</span>
                                    </div>
                                  }
                                  <span class="secundary">Uso: {{item.usage}}</span>
                                  <span class="secundary">Via: {{item.administrationTypeName}}</span>
                                  <span class="secundary">Apresentação: {{item.presentationName}}</span>
                                  <span class="secundary">Frequência: {{item.frequencyName}}</span>
                                  <span class="secundary">Periodo trat.: {{item.treatmentPeriodName}}</span>
                                  @if (item.motiveSuspended) {
                                    <span [matTooltip]="item.motiveSuspended" class="secundary">Motivo da suspensão: {{item.motiveSuspended | truncateText:50}}</span>
                                  }
                                  @if (item.medicNameSuspended || item.nurseNameSuspended) {
                                    <span class="secundary">
                                      Responsável pela suspensão: {{item.medicNameSuspended ? item.medicNameSuspended : item.nurseNameSuspended}}; {{ item.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}
                                    </span>
                                  }
                                </div>
                                @if (!isHistory && !validateActionSuspendedSolutionPrescription(item.prescriptionSolution.idPrescriptionSolution)) {
                                  <div class="actions">
                                    <button>
                                      <mat-icon aria-hidden="false" aria-label="Ver mais"
                                      (click)="openPrescriptionModal(item, true)">block</mat-icon>
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                  @if (!('validateGeneral' | validateThereArePrescriptions:itemMedicalCare:isHistory:null:idCurrentMedicalCare)) {
                    <app-empty-list [message]="messageEmptyListPrescription()"></app-empty-list>
                  }
                </div>
              </div>
            </cdk-accordion-item>
          }
        }
      </div>
    }
  </div>
</div>
<div mat-dialog-footer class="footer-modal">
  <div class="row">
    <div class="col-12 col-md-6">
      <button mat-flat-button type="button" color="accent" class=" btn-block" (click)="close()">
        @if (isLoading == false) {
          <span>Fechar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    @if (!isHistory) {
      <div class="col-12 col-md-6">
        <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="cancel()">
          @if (isLoading == false) {
            <span>Cancelar suspensão</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
      </div>
    }
  </div>
</div>